//The data is obtained from AW-Singapore-Business-Protector-Travel-Protector.pdf
import { getPlanLabel } from "./labels";
import { PricingPlan } from "../../types/travel/new-policy/api/Pricing";
import { formatToTwoDecimalsWithThousandSeparator } from "../shared/format";

const priceTableLabels = [
  "Accidental Death & Permanent Disablement",
  "Overseas Medical Expenses",
  "Post Journey Medical Expenses",
  "Travel Cancellation",
  "Travel Delay",
  "Delayed Baggage",
];

// TODO: Why is this in the frontend????
const defaultPriceTables: Table[] = [
  {
    header: { label: "", value: "" },
    rows: [
      { value: "SGD 150,000" },
      { value: "SGD 200,000" },
      { value: "SGD 10,000" },
      { value: "SGD 5,000" },
      { value: "SGD 1,000" },
      { value: "SGD 1,000" },
    ],
  },
  {
    header: { label: "", value: "" },
    rows: [
      { value: "SGD 250,000" },
      { value: "SGD 500,000" },
      { value: "SGD 30,000" },
      { value: "SGD 10,000" },
      { value: "SGD 1,000" },
      { value: "SGD 1,000" },
    ],
  },
  {
    header: { label: "", value: "" },
    rows: [
      { value: "SGD 500,000" },
      { value: "SGD 500,000" },
      { value: "SGD 50,000" },
      { value: "SGD 15,000" },
      { value: "SGD 1,000" },
      { value: "SGD 1,000" },
    ],
  },
];

export interface ITable {
  headers: TableHeader[];
  rows: IRows[];
}

interface IRows {
  cells: ICell[];
}

interface ICell {
  value: string;
}

interface Table {
  header: TableHeader;
  rows: TableRow[];
}

interface TableHeader {
  label: string;
  value: string;
  childValue?: string;
}

interface TableRow {
  value: string;
}

export const createTravelPlanPriceTable = (plans: PricingPlan[]) => {
  const tables: ITable[] = [];
  defaultPriceTables.forEach((priceTable, index) => {
    const rows = priceTable.rows.map((row, rowIndex) => ({
      cells: [{ value: priceTableLabels[rowIndex] }, { value: row.value }],
    }));

    const basePrice = formatToTwoDecimalsWithThousandSeparator(plans[index].price.basePrice ?? plans[index].price.price);
    const childPrice = formatToTwoDecimalsWithThousandSeparator(plans[index].childPrice ?? 0);
    tables.push({
      headers: [{ label: getPlanLabel(plans[index].id), value: `SGD ${basePrice}`, childValue: `SGD ${childPrice}` }],
      rows: rows,
    });
  });

  return tables;
};
